class CartController {
  constructor() {
    this.state = this.loadState();
    this.bindEvents();
    // 初期化時に状態をチェック
    this.updateCartUI();
  }

  loadState() {
    return {
      hasRestrictedProduct: false,
      restrictedCount: 0,
      normalCount: 0,
      groupTags: new Set()
    };
  }

  checkRestrictions() {
    // look for any product name element inside the cart or drawer
    // previous implementation only targeted `form#cart` which exists
    // on the full cart page; the drawer uses a different form ID so
    // the selector would return an empty NodeList once the inline
    // product-page script was removed.  Using a broader selector
    // keeps the restriction logic working regardless of where the
    // user is on the site.
    const items = document.querySelectorAll('.cart-item__name');
    let state = this.loadState();

    items.forEach(item => {
      // タグが取得できない場合のデバッグログ
      console.log('Item tags:', item.dataset.tags);
      
      const tags = item.dataset.tags?.split(',') || [];
      let hasGroupTag = false;
      let hasNormalStock = false;

      tags.forEach(tag => {
        if (tag.trim() === '同時購入不可') {
          state.hasRestrictedProduct = true;
          state.restrictedCount++;
        } else if (tag.trim() === '通常在庫') {
          hasNormalStock = true;
        } else if (tag.trim().startsWith('同時購入グループ')) {
          hasGroupTag = true;
          state.groupTags.add(tag.trim());
        }
      });

      if (!hasGroupTag && !state.hasRestrictedProduct) {
        hasNormalStock = true;
      }

      if (hasNormalStock) {
        state.normalCount++;
      }
    });

    console.log('Cart state:', state); // デバッグログ
    return state;
  }

  validateCart(state) {
    const isInvalid = 
      state.restrictedCount > 1 ||
      (state.restrictedCount === 1 && (state.normalCount > 0 || state.groupTags.size > 0)) ||
      state.groupTags.size > 1 ||
      (state.groupTags.size > 0 && state.normalCount > 0);

    console.log('Cart validation result:', !isInvalid); // デバッグログ
    return !isInvalid;
  }

  updateCartUI() {
    const state = this.checkRestrictions();
    const isValid = this.validateCart(state);

    // すべてのチェックアウトボタンを取得
    const checkoutButtons = document.querySelectorAll('[name="checkout"], #CartDrawer-Checkout, #checkout');
    const errorMessages = document.querySelectorAll('#confuseError');

    checkoutButtons.forEach(button => {
      if (button) {
        button.disabled = !isValid;
        console.log('Checkout button state:', button.disabled); // デバッグログ
      }
    });

    errorMessages.forEach(message => {
      if (message) {
        message.style.display = isValid ? 'none' : 'block';
      }
    });
  }

  bindEvents() {
    // カート更新イベントの監視
    document.addEventListener('cart:updated', () => {
      console.log('Cart updated event triggered'); // デバッグログ
      this.updateCartUI();
    });

    // ドロワー開閉イベントの監視
    document.addEventListener('cart-drawer:opened', () => {
      console.log('Cart drawer opened event triggered'); // デバッグログ
      // sometimes the drawer content is injected immediately after
      // the open event; add a tiny delay so the DOM is settled before
      // re-checking.  This avoids a situation where the mutationdetects no items and re-enables the checkout button.
      setTimeout(() => this.updateCartUI(), 50);
    });

    // Fetch APIの監視
    this.interceptFetchRequests();
  }

  interceptFetchRequests() {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      
      if (args[0].includes('/cart/add') || args[0].includes('/cart/change') || args[0].includes('/cart/update')) {
        console.log('Cart fetch intercepted:', args[0]); // デバッグログ
        setTimeout(() => this.updateCartUI(), 500);
      }
      
      return response;
    };
  }
}

// グローバルインスタンスの作成
window.cartController = new CartController();